import { removeCaseFile } from '@/backend/case'
import { useCaseQuery } from '@/data/Cases/useCaseQuery'
import { ApiError } from '@/shared/utils/error'
import { invariant } from '@/shared/utils/typeAssertions'
import { useMutation } from '@tanstack/vue-query'
import { type Ref } from 'vue'

export const useDeleteCaseFile = ({ caseId, workspaceId }: Params) => {
  const { data: caseData, deleteCaseFile } = useCaseQuery(caseId, workspaceId, { enabled: false })

  return useMutation({
    mutationFn: async (params: MutationParams) => {
      invariant(caseId.value && workspaceId.value)
      const res = await removeCaseFile(workspaceId.value, caseId.value, params.fileId)
      if (!res.ok) {
        throw ApiError.fromFailedResult(res)
      }

      return res.data
    },
    onMutate: (params) => {
      const fileIndex = caseData.value?.files.findIndex((f) => f.id === params.fileId)
      const file = caseData.value?.files[fileIndex ?? -1]
      deleteCaseFile(params.fileId)
      return { file, fileIndex }
    },
    onError: (error, params, context) => {
      if (context?.file && context.fileIndex !== undefined) {
        caseData.value?.files.splice(context.fileIndex, 0, context.file)
      }
      throw error
    },
  })
}

type Params = {
  caseId: Ref<string>
  workspaceId: Ref<string>
}

type MutationParams = {
  fileId: string
}
